import { Action, Dispatch } from "redux";
import * as actions from "./actions";

export const saveNewToken = async (token: any) => async (
  dispatch: Dispatch<Action<any>>
) => {
  window.localStorage.setItem("token", token);
  dispatch(actions.setNewToken.started(token));
};

export const logOutAuth = () => {
  return (dispatch: Dispatch) => {
    dispatch(actions.logOutAuth.started(true));
  };
};
